<template>
    <div class="submit-order">
      <div class="submit">
        <div class="s-info">
          <p class="finalprice">应付金额 : RMB {{finalPrice}}</p>
          <p class="discount">总计优惠 : RMB {{totalHeadDiscount}}</p>
          <p class="freight">运费: RMB {{freight}}</p>
        </div>
        <div @click="createOrder" class="s-btn">提交订单</div>
      </div>
      <div class="address">
        <div @click="selectAddress" class="a-top">
          <p v-if='currentAddress.realName' class="receiver">{{currentAddress.realName}}   {{currentAddress.mobNumber}}</p>
          <p style="text-align: center;font-size: 20px;color: #999;margin-top: 11px;" v-else>添加地址</p>
          <p v-if="currentAddress.defaultFlag=='Y'" class="default">默认地址</p>
        </div>
        <div class="a-bottom">
          {{currentAddress.provinceName}}{{currentAddress.cityName}}{{currentAddress.districtName}}{{currentAddress.streetName}}{{currentAddress.address1}}
        </div>
      </div>
      <img class="adr-bg" src="../assets/image/order/address-bg.png">
      <!--<div class="promotion">-->
        <!--<p><span class="manjian">满减</span>整单满10000元,可享立减100元优惠<span class="red">还差50元</span><span class="piece">去凑单></span></p>-->
        <!--<p><span class="manjian">满减</span>整单满10000元,可享立减100元优惠</p>-->
      <!--</div>-->
      <div class="goods-list">
        <div class="goods-img">
          <div v-for="item in mainList">
            <img :src="BASE_URL+item.imgURL">
          </div>
        </div>
        <div class="goods-info">
          <div class="info-left">
            <p>商品件数:</p>
            <p>总商品金额:</p>
          </div>
          <div class="info-right">
            <p>{{totalQuantity}}</p>
            <p>RMB {{finalPrice}}</p>
          </div>
        </div>
      </div>
      <div class="order-info">
        <div class="info-paytype" @click="goPayType">
          <p>支付方式</p>
          <p v-if="paymentType=='online'">在线支付</p>
          <p v-if="paymentType=='banktransfer'">银行转账</p>
        </div>
        <div class="info-invoice" @click="goInvoice">
          <div class="invoice-title">
            <p>电子发票抬头</p>
            <p>{{invoiceTitle}}</p>
          </div>
          <div class="invoice-example">
            <p>关于电子发票</p>
            <p>个人发票样章</p>
            <p>公司发票样章</p>
          </div>
        </div>
        <div class="info-remark">
          <p>订单备注
          <span>{{remarks}}</span>
          </p>
        </div>
      </div>
      <div class="rule">
          <div class="rule_title">订购服务条款</div>
          <div class="rule_nav clearfix">
            <a href="javascript:void(0)" class="rnav" v-for="(rule,index) in rules" :class="{active:(index==agreeIndex)}" :data-num="index" @click="changeRule(index)">{{rule.name}}</a>
          </div>
          <div class="rule_con">
            <div class="rule_item" v-for="(rule,index) in rules" v-show="index == agreeIndex">
              <!--<p class="titler" v-cloak>{{rule.name}}</p>-->
              <div>
                <p class="indent" v-for="content in replaceMessage(rule.content)" v-cloak>{{content}}</p>
              </div>
            </div>

          </div>
        <div class="check_z clearfix">
          <input type="checkbox" id="check1" checked>
          <label for="check1">全部同意以上条款</label>

        </div>
        <!--<div class="notice">-->

          <!--<p>注：支付状态更新有延时，如您已经完成在线支付，请勿再次点击以上支付按钮以避免重复支付-->
          <!--</p>-->
          <!--<p>根据您已阅读过的销售条款和条件，如您的订单被接受的情形下，我们将另行通过电子邮件或其他方式向您发出承诺接受的通知。</p>-->
          <!--<p>由于页面设置，打印格式等原因，最终寄送给您的订购明细或发票上的印刷各商品信息（包括名称，单价，总价）可能与本页面目前显示有所差异，但订单的商品合计金额不会变化。-->
          <!--</p>-->
        <!--</div>-->
      </div>
      <div style="display:none;" class="coupon">
        <p class="coupon-title">优惠券<span>选择最高优惠</span></p>
        <div class="coupon-list">
          <div class="c-item">
            <img class="c-bg" src="../assets/image/order/coupon-gray.png">
            <div class="c-info">
              <div class="c-left">
                <p class="c-price">$60</p>
                <p>满300</p>
              </div>
              <div class="c-right">
                <p>仅限电视机品类</p>
                <p class="c-validity">有效期:08-24至08-24</p>
              </div>
            </div>
          </div>
          <div class="c-item">
            <img class="c-bg" src="../assets/image/order/coupon-gray.png">
            <div class="c-info">
              <div class="c-left">
                <p class="c-price">$60</p>
                <p>满300</p>
              </div>
              <div class="c-right">
                <p>仅限电视机品类</p>
                <p class="c-validity">有效期:08-24至08-24</p>
              </div>
            </div>
          </div>
          <div class="c-item">
            <img class="c-bg" src="../assets/image/order/coupon-blue.png">
            <div class="c-info">
              <div class="c-left">
                <img src="../assets/image/order/coupon-gift.png">
              </div>
              <div class="c-right">
                <p>仅限电视机品类</p>
                <p class="c-validity">有效期:08-24至08-24</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>
<style scoped lang="less">
  @fontColor: #4d4d4d;
  @blue: #0a83d7;
  .submit-order {
    background-color: rgb(242,242,242);
    padding-bottom: 100px;
  }
.address {
  background: url("../assets/image/order/address.png") 18px center no-repeat #ffffff;
  background-size: 23px;
  padding: 20px 15px 20px 50px;
  .a-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .receiver {
      font-size: 15px;
      color: @fontColor;
    }
    .default {
      font-size: 12px;
      color: #ffffff;
      background-color: @blue;
      padding: 2px 4px;

    }
  }
  .a-bottom {
    font-size: 12px;
    background: url("../assets/image/order/arrow-right.png") right 3px no-repeat;
    background-size: 6px;
    padding-right: 35px;
    margin-top: 12px;
  }
}
  .adr-bg{
    width:100%;
    height:3px;
    vertical-align: text-top;
  }
  .promotion {
    font-size: 9px;
    color: #666666;
    padding: 15px 18px;
    .manjian {
      color: #b50000;
      border: 1px solid #b50000;
      margin-top: 3px;
    }
    .red {
      color: #b50000;
    }
    .piece {
      font-size: 10px;
      background-color: #b50000;
      color: #ffffff;
      margin-left: 5px;
    }
  }
  .goods-list {
    padding: 25px 18px;
    background-color: #ffffff;
    .goods-img {
      overflow: hidden;
      white-space: nowrap;
      padding-bottom: 15px;
      border-bottom: 1px dotted #9f9f9f;
      padding-right: 20px;
      /*background: url("../assets/image/order/arrow-right.png") right 42% no-repeat;*/
      background-size: 6px;
      div {
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 1px solid #9f9f9f;
        margin-right: 10px;
        display: inline-block;
      }
      img {
        width: 90%;
      }
    }
    .goods-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: @blue;
      font-size: 11px;
      text-align: end;
      margin-top: 8px;
      .info-left {
        margin-right: 10px;
      }
      .info-right {

      }
    }
  }
  .order-info {
    margin: 20px 0;
    padding: 30px 18px;
    background-color: #ffffff;
    .info-paytype,.info-remark,.invoice-title {
      height: 30px;
      font-size: 10px;
      color: @fontColor;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 18px;
      background: url("../assets/image/order/arrow-right.png") right center no-repeat;
      background-size: 6px;
      border-top: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
    }
    .invoice-example {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: @blue;
      text-decoration: underline;
      font-size: 9px;
      margin-bottom: 12px;
      p {
        margin-right: 20px;
      }
    }
    .invoice-title {
      border-bottom: none;
    }
    .info-remark {
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          color: #999999;
        }
      }
    }
  }
  .rule{ width:100%;padding: 0 18px;background-color: #ffffff;margin-bottom: 20px;}
  .rule_title{ padding:24px 0 12px 0; color:#3b3a3a; font-size:13px;}
  .rule_nav{ width:100%; height:50px; border:1px solid #9f9f9f;display: table}
  .rule_nav a{background-color: #ebecee; width:25%; vertical-align: middle;padding: 0 3px; border-right:1px solid #9f9f9f; display: table-cell; text-align:center; padding-top:3px; text-decoration:none;color:@fontColor; font-size:12px;}

  .rule_nav a:last-child{ border:0 none; }
  .rule_nav a.active{ color:#ffffff; background-color:@blue;}
  .rule_con{ width:100%; height:180px; margin-top:12px; overflow:hidden; overflow-y:scroll; -webkit-overflow-scrolling:touch; z-index: 0 !important;}
  .rule_item{ padding:12px 12px 3px;}
  .rule_item  p{color:#949494; font-size:10px; line-height:18px;}
  .rule_item  p.titler{ color:#3a3a3a; font-size:8px; line-height:18px;}
  .rule_item  p.indent{ text-indent: -8px;  padding-left: 8px;}
  label {
    display: inline-block;
    padding-left:20px;
    font-size: 12px;;
    color:@fontColor;
    position: relative;
  }
  input[type=radio],input[type=checkbox] {
    display: none;
  }
  label:before {
    content: "";
    display: inline-block;
    margin-right: 0;
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 15px;;
    height: 15px;;
    background:url(../assets/image/order/d_check.png) no-repeat;
    background-size:cover;

  }
  input[type=checkbox]:checked + label:before {
    background:url(../assets/image/order/d_checked.png) no-repeat;
    background-size:cover;
  }
  .check_z{ padding: 12px 0 25px 0; border-top:1px dotted #e0e0e0;margin-top: 20px;}
  .coupon {
    background-color: #ffffff;
    padding: 25px 18px;
    .coupon-title {
      color: @fontColor;
      font-size: 11px;
      span {
        color: #999999;
        font-size: 9px;
      }
    }
    .coupon-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      border-top: 1px solid #efefef;
      .c-item {
        position: relative;
        width: 46%;
        margin-top: 10px;
        .c-bg {
          width: 100%;
        }
        .c-info {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
          font-size: 9px;
          .c-left {
            width: 32%;
            display: flex;
            align-items: center;
            flex-direction: column;
            img {
              width: 50%;
            }
          }
          .c-right {
            width: 60%;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
          }
          .c-price {
            font-size: 18px;
          }
          .c-validity {
            font-size: 7px;
          }
        }
      }
    }
  }
  .submit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 85px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 66;
    .s-info {
      text-align: right;
      .finalprice {
        color: #0a83d7;
        font-size: 11px;
      }
      .discount {
        color: #999999;
        font-size: 11px;
        margin-top: 3px;
      }
      .freight {
        color: #999999;
        font-size: 11px;
      }
    }
    .s-btn {
      width: 160px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      margin: 0 18px;
      background-color: #0d70d2;
      color: #ffffff;
      font-size: 13px;
    }
  }
</style>
<script>
import agreementData from '../assets/json/agreement'
    export default{
        data(){
            return{
                api: this.$store.state.api,
                BASE_URL: BASE_URL,
                cartId: '',
                paymentType: this.$store.state.paymentType,
                remarks: '',
                addressId: '',
                invoiceCode: this.$store.state.invoiceCode,
                invoiceType: 'E_INVOICE_SONYSTYLE',
                isRegisteredAutoProduct: '',
                invoiceTitle: this.$store.state.invoiceCode=='Person'?this.$store.state.invoiceTitle1:this.$store.state.invoiceTitle2,
                companyTaxCode: this.$store.state.companyTaxCode,
                mainList: [],
                itemList: [],
                finalPrice: '',
                freight: '',
                totalQuantity: '',
                totalHeadDiscount: '',
                currentAddress: {},
                rules: agreementData,
                agreeIndex: 0
            }
        },
        components:{

        },
        created() {
          this.getCart();
        },
        methods: {
          changeRule(_index) {
            this.agreeIndex = _index;
          },
          replaceMessage(val){
						return val.split('\n');
					},
					selectAddress() {
            let url = `${BASE_URL}/content/dam/sonystyle-club/index.html#/address?from=wechat`;
            window.location.href=url;
					},
          addAddress() {
            let url = 'https://pet.sonystyle.com.cn/eSolverOmniChannel/address/addShipToAddress.do?access_token=b833df56-d0cc-4628-aebb-cfe3163ae115&channel=WAP';
            this.$http.post(url,JSON.stringify({
                "realName":"Eliza",
                "gender":"MALE",
                "province":"30",
                "city":"022",
                "district":"022001",
                "street":"02200100002",
                "mobNumber":"18257341890",
                "address1": "testAddressOne"
              })
            ).then(res => {

            }).catch(res => {

            })
          },
          getAddressByid() {
            let url = this.api.address.getAddress(this);
            this.$http.post(url,{
              addrNumber: this.addressId
            }).then(res=>{
              if(res.data.resultMsg[0].code=='00'&&res.data.resultMsg[0].message=='success'){
                this.currentAddress = res.data.resultData.addressList[0];
              }
            })
          },
            createOrder() {
              let url = this.api.order.createOrder(this);
              this.$http.post(url,JSON.stringify({
                    cartId: this.cartId,
                    paymentType: this.paymentType,
                    remarks: this.remarks,
                    addressId: this.addressId,
                    invoiceType: this.invoiceType,
                    invoiceCode: this.invoiceCode,
                    //isRegisteredAutoProduct: this.isRegisteredAutoProduct,
                    invoiceTitle: this.invoiceTitle,
                    //companyTaxCode: this.companyTaxCode
                })
              ).then(res => {
                if(res.data.resultMsg[0].code=='00'&&res.data.resultData.orderId){
                    this.$router.push({path:'/PaySuccess',query:{
                      orderId: res.data.resultData.orderId
                    }});
                }else if(res.data.resultMsg[0].message){
                  alert(res.data.resultMsg[0].message);
                }
              }).catch(res => {

              })

            },
            getCart() {
              let url = this.api.cart.readCart(this);
              this.$http.post(url,{})
              .then(res=>{
                if(res.data.resultMsg[0].code=='00'){
                   this.itemList = res.data.resultData.itemList;
                   this.cartId = res.data.resultData.header.cartId;
                   this.addressId = this.$route.query.addrNumber?this.$route.query.addrNumber:res.data.resultData.header.dAddressNo;
                   this.finalPrice = res.data.resultData.header.finalPrice;
                   this.freight = res.data.resultData.header.freight;
                   this.totalQuantity = res.data.resultData.header.totalQuantity;
                   this.totalHeadDiscount = res.data.resultData.header.totalHeadDiscount;
                   if(this.itemList) {
                    this.resolveList(this.itemList);
                   }else {
                    this.mainList = [];
                   }
                   if(this.addressId){
                     this.getAddressByid();
                   }
                }
              })
              .catch({

              })
            },
            goPayType() {
              this.$router.push({name:'PayType'});
            },
            goInvoice() {
              this.$router.push({name:'InvoiceEdit'});
            },
            resolveList(data) {
                this.mainList = [];
                var url = this.api.product.findMasterData();
                for(let i=0;i<data.length;i++){
                    this.$http.get(url,
                      {
                        params: {
                        'eightD': data[i].product8D
                        }
                      }
                    ).then(res=>{
                      if(res.data.result && res.data.code=='00') {
                      console.log(data[i].product8D+':'+res.data.returnData.OutMasterData.imagePath)
                        data[i].imgURL = res.data.returnData.OutMasterData.imagePath;
                        this.mainList.push(data[i]);
                      }
                    })
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/SubmitOrder.vue